import React from 'react';
import './SecuritySafetyHero.css';

const SecuritySafetyHero = () => {
    return (
        <section className="security-hero">
            <div className='security-hero-overlay'>
                <div className="security-hero-content">
                    <h1>Security & Public Safety</h1>
                    <p>Ensuring a safe and secure environment for all citizens of Igboeze North.</p>
                </div>
            </div>
        </section>
    );
};

export default SecuritySafetyHero;